import { useEffect, useReducer, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import DashboardContainer from "../../components/dashboard-container";
import CatalogList from "../../components/catalog-list";
import { catalogFilterInitialState } from "../../utils/filter-config";
import buildQuery from "../../utils/query-builder";
import { catalogService } from "../../utils/services/catalogService";
import ImportIcon from "../../globalStyles/icons/import-icon";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state.columns.map((x) =>
          x.key === action.payload.key ? { ...x, ...action.payload } : x,
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    case "EXISTING_DATA":
      return {
        ...state,
        columns: state.columns.map((x) => ({
          ...x,
          filter:
            action.data.filters.find((y) => y.key === x.key)?.values ||
            x.filter,
        })),
        limit: action.data.limit || state.limit,
      };
    default:
      return state;
  }
}

export default function Catalog() {
  const [filterData, dispatch] = useReducer(
    filterReducer,
    catalogFilterInitialState,
  );
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const data = localStorage.getItem("catalog-filter-data");
    if (location.search.includes("child") && data) {
      localStorage.removeItem("catalog-filter-data");
      dispatch({ type: "EXISTING_DATA", data: JSON.parse(data) });
    }
  }, []);
  const [catalogData, setCatalogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [dataCount, setDataCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const clientId = localStorage.getItem("client_id");

  const fetchCatalogData = async (signal) => {
    setLoading(true);
    try {
      const response = await catalogService.fetch(
        clientId || null,
        searchValue,
        buildQuery(filterData, page),
        { signal },
      );
      setCatalogData(response.data);
      setDataCount(response.total);
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchCatalogData(controller.signal);
    return () => controller.abort();
  }, [filterData, searchValue, page, fetchTrigger]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  return (
    <>
      <DashboardContainer
        searchBarPlaceholder="Search by Catalog Name"
        filterData={filterData}
        fields={filterData.columns}
        hideUploadButton
        showRefreshButton
        onClickRefresh={() => setFetchTrigger((n) => n + 1)}
        onSearchData={(x) => {
          setSearchValue(x.trim() ? x : "");
          setPage(0);
        }}
        onClickAddButton={() => navigate("/manage-catalog/create")}
        header="Catalog List"
        title="+ Add Catalog"
        hideFilterClient
        headerButtons={
          !clientId ? (
            <></>
          ) : (
            <Button
              size="small"
              style={{
                textTransform: "none",
                marginRight: 10,
              }}
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/catalog-import");
              }}
            >
              <ImportIcon fill={"#ffff"} />
              <Typography
                fontSize="14px"
                fontWeight={500}
                sx={{
                  color: "#FFF",
                  marginLeft: 1,
                }}
                fontFamily={"poppins"}
              >
                Import
              </Typography>
            </Button>
          )
        }
      >
        {/* {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        )} */}
        <CatalogList
          data={catalogData}
          onEditData={() => setFetchTrigger((n) => n + 1)}
          onDeleteData={() => setFetchTrigger((n) => n + 1)}
          dataCount={dataCount}
          page={page}
          rowsPerPage={filterData.limit}
          setPage={setPage}
          setRowsPerPage={(val) =>
            dispatch({ type: "UPDATE_LIMIT", payload: val })
          }
          filterData={filterData}
          onChangeFilter={handleFilterChange}
          client_id={clientId}
          loading={loading}
          setLoading={setLoading}
        />
      </DashboardContainer>
    </>
  );
}
